import React from 'react';
import cx from 'classnames';

import { CancelProgress } from './CancelProgress';
import { CompletedProgress } from './CompletedProgress';
import { GoProgress } from './GoProgress';
import { getInnerIndicatorRight } from '../utils';
import { EstimateCell } from './EstimateCell';

const getProgressContent = (row, stages, disableProgressAnimations) => {
  if (row.isCanceled) {
    return <CancelProgress row={row} />;
  }

  if (row.isCompleted) {
    return <CompletedProgress stages={stages} row={row} />;
  }

  return <GoProgress row={row} stages={stages} disableProgressAnimations={disableProgressAnimations} />;
};

const getIndicatorStyle = (row, stages) => {
  const stageNumber = row.status.stage || 1;

  return {
    right: getInnerIndicatorRight(stages, stageNumber),
  };
};

export const QueueProgress = ({ row, stages, disabledStatuses, mini = false, disableProgressAnimations }) => {
  if (disabledStatuses.includes(row.statusName.value)) {
    return null;
  }

  return (
    <div className={cx('queue-table', { mini })}>
      {getProgressContent(row, stages, disableProgressAnimations)}

      {row.innerTaskDelay ? (
        <div
          className={cx('queue-table__delay-indicatior', row.innerTaskDelayColor || 'red')}
          style={getIndicatorStyle(row, stages)}
        >
          {row.innerTaskDelay}
        </div>
      ) : null}

      {row.stagesEstimate &&
        row.stagesEstimate.map(estimate => (
          <EstimateCell
            key={estimate.stageName}
            item={estimate}
            stages={stages}
            disableProgressAnimations={disableProgressAnimations}
          />
        ))}
    </div>
  );
};
